import { styled } from 'linaria/lib/react';
import { COLORS, FONTS } from 'styles/constants';

// Section container
export const StyledFeaturedSparksSection = styled.div`
  padding: 24px 0;
`;

// Header container
export const StyledHeader = styled.div`
  padding: 0 24px;
  margin-bottom: 20px;
`;

// Title text - "Popular Sparks"
export const StyledTitle = styled.h2`
  font: 400 22px/130% ${FONTS.primary};
  color: ${COLORS.brown.dark[100]};
  margin: 0 0 4px 0;
`;

// Subtitle text - "Curated questions set the theme"
export const StyledSubtitle = styled.p`
  font: 400 14px/140% ${FONTS.secondary};
  color: ${COLORS.brown.light[100]};
  margin: 0;
`;

// Slider wrapper
export const StyledSliderWrap = styled.div`
  display: flex;

  > div {
    flex: 1;
  }

  .swiper-slide {
    height: auto;
    width: 170px;
  }
`;

// Small spark card container
export const StyledSparkCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 170px;
`;

// User row (avatar + thought text)
export const StyledUserRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 0 12px;
`;

// Avatar container
export const StyledAvatarWrap = styled.div`
  flex-shrink: 0;
  padding-right: 8px;
`;

// Thought text (the quote)
export const StyledThoughtText = styled.div`
  font: 600 14px/140% ${FONTS.secondary};
  color: ${COLORS.brown.dark[100]};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 40px;
  flex: 1;
`;

// Cover container
export const StyledCover = styled.div<{ bgImage?: string }>`
  width: 100%;
  height: 218px;
  border-radius: 10px;
  background: ${({ bgImage }) => (bgImage ? `url(${bgImage})` : COLORS.gray[100])};
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
`;

// Video cover (for animated covers)
export const StyledCoverVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

// Footer row (spark icon button)
export const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 0 0 12px;
  height: 20px;
`;

// Spark icon button
export const StyledSparkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 22px;

  svg {
    width: 24px;
    height: 24px;
    color: ${COLORS.brown.dark[100]};
  }
`;
